/* Ported from Uncover Creations: quick-view drawer for Ready Mades.
   Only the drawer IIFE is ported - UC's other blocks (countdown, promo
   scroll, sticky header) are UC-specific and deliberately left out. */

/* UC Dynamic Content Drawer (uses Impact's built-in x-drawer) */
(function() {
  function ucOpenProductAccordions(container) {
    const descriptionAccordion = container.querySelector(
      '.product-info__block-item[data-block-type="collapsible-text"] details'
    );
    if (!descriptionAccordion) return;
    descriptionAccordion.open = true;
    descriptionAccordion.setAttribute('aria-expanded', 'true');
    const content = descriptionAccordion.querySelector('.accordion__content');
    if (content) {
      content.style.opacity = '1';
      content.style.transform = 'none';
    }
  }

  function ucOpenDrawer(event, trigger) {
    event.preventDefault();
    const drawer = document.getElementById('uc-drawer');
    const titleEl = document.getElementById('uc-drawer-title');
    const contentEl = document.getElementById('uc-drawer-content');
    let url = trigger.getAttribute('data-url');
    // Triggers are wired via inline onclick in section JSON, so a missing
    // data-url is possible; bail before preventDefault swallows the click.
    if (!url) return;

    // Handle hash anchors
    let hash = null;
    if (url.includes('#')) {
      const parts = url.split('#');
      url = parts[0];
      // '/x#' would yield '#', and querySelector('#') throws a SyntaxError.
      hash = parts[1] ? '#' + parts[1] : null;
    }

    // Clear any previous quick-view styling. These classes were only ever
    // added, never removed, so once a Ready-Made quick view had been opened
    // every later drawer (offers page, returns policy, cart upsell) inherited
    // its CSS - zeroed padding, hidden ratings - until a full page reload.
    contentEl.classList.remove('uc-drawer--quickview');
    drawer.classList.remove('uc-drawer--quickview-active');

    // Token guards against a slow first request overwriting a newer one.
    const requestToken = (ucOpenDrawer._token = (ucOpenDrawer._token || 0) + 1);

    // Show loading state and open drawer via x-drawer API
    contentEl.innerHTML = 'Loading content...';
    titleEl.textContent = 'Loading...';
    drawer.show();

    // Fetch and render content
    fetch(url)
      .then(response => {
        // Shopify's 404 page also has #main, so without this check a renamed
        // or unpublished product renders as a stripped 404 titled "Drawer".
        if (!response.ok) throw new Error('HTTP ' + response.status + ' for ' + url);
        return response.text();
      })
      .then(html => {
        // A newer click superseded this one - drop the stale response.
        if (requestToken !== ucOpenDrawer._token) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const mainContent = doc.querySelector('#main');

        // Update drawer title
        let title = 'Drawer';
        if (trigger.getAttribute('data-url').includes('/products/')) {
          const productTitle = doc.querySelector('.product-info__title');
          if (productTitle) title = productTitle.textContent.trim();
        } else {
          const pageTitle = doc.querySelector('title');
          if (pageTitle) title = pageTitle.textContent.trim();
        }
        titleEl.textContent = title;

        // Remove unwanted elements
        if (mainContent) {
          mainContent.querySelectorAll('.shopify-section-group-footer-group').forEach(el => el.remove());
          mainContent.querySelectorAll('h1').forEach(el => el.remove());

          if (trigger.getAttribute('data-url').includes('/products/')) {
            mainContent.querySelectorAll('.h2').forEach(el => el.remove());
            mainContent.querySelectorAll('.breadcrumb').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--rich-text').forEach(el => el.remove());
            mainContent.querySelectorAll('.jdgm-review-widget').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--product-recommendations').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--recently-viewed-products').forEach(el => el.remove());
            mainContent.querySelectorAll('.product-info__payment-terms').forEach(el => el.remove());
          }

          contentEl.innerHTML = mainContent.innerHTML;

          // Re-execute injected <script> tags so anything inline can run.
          contentEl.querySelectorAll('script').forEach(oldScript => {
            const s = document.createElement('script');
            for (const attr of oldScript.attributes) s.setAttribute(attr.name, attr.value);
            s.text = oldScript.textContent;
            oldScript.parentNode.replaceChild(s, oldScript);
          });

          // â”€â”€â”€ Quick-view treatment (eye-button on Ready Made cards only) â”€â”€â”€
          // The trigger sets data-quickview="ready-made". We strip everything
          // except the first .shopify-section (the main-product section) so the
          // drawer shows just the product info â€” images, title, price, variant
          // picker, add-to-cart, description. No related products, no reviews.
          // Drawer uses from other triggers (no data-quickview) are unaffected.
          if (trigger.getAttribute('data-quickview') === 'ready-made') {
            // Keep the main-product section specifically. Do NOT assume it is
            // first: on Sinnovator a custom-liquid section precedes it, and
            // keeping index 0 deleted the product entirely.
            const sections = Array.from(contentEl.querySelectorAll('.shopify-section'));
            const keep = sections.find(s =>
              s.classList.contains('shopify-section--main-product') || s.querySelector('.product-info')
            ) || sections[0];
            sections.forEach(sec => { if (sec !== keep) sec.remove(); });

            // Scope class so all quickview-specific CSS only targets here.
            contentEl.classList.add('uc-drawer--quickview');
            drawer.classList.add('uc-drawer--quickview-active');

            // Move buy_buttons block to sit directly after the price block
            const priceBlock = contentEl.querySelector('.product-info__block-item[data-block-type="price"]');
            const buyButtonsBlock = contentEl.querySelector('.product-info__block-item[data-block-type="buy-buttons"], .product-info__block-item[data-block-type="buy_buttons"]');
            if (priceBlock && buyButtonsBlock && priceBlock !== buyButtonsBlock) {
              priceBlock.insertAdjacentElement('afterend', buyButtonsBlock);
            }

            // Strip blocks that render invisibly but still take vertical space:
            //   - variant-picker (Ready Mades have 1 variant)
            //   - LPO app block (empty placeholder Cloudlift can't bind to)
            //   - collapsible-text accordions whose body is empty (e.g. Description
            //     when product.description is blank)
            //   - any block whose visible text+media content is empty
            contentEl.querySelectorAll('.product-info__block-item').forEach(block => {
              const type = block.getAttribute('data-block-type');
              if (type === 'variant-picker' || type === 'variant_picker') {
                block.remove();
                return;
              }
              // Empty LPO placeholder
              if (block.querySelector('[data-live-options]')) {
                block.remove();
                return;
              }
              // Collapsible-text with empty body (Description when product.description is blank)
              if (type === 'collapsible-text' || type === 'collapsible_text') {
                const body = block.querySelector('.accordion__content');
                if (body && body.textContent.trim().length === 0) {
                  block.remove();
                  return;
                }
              }
              // Block has no visible text and no media â€” pure empty spacer
              const hasText = block.textContent.trim().length > 0;
              const hasMedia = block.querySelector('img, svg, video, iframe, picture, hr, input, button');
              if (!hasText && !hasMedia) {
                block.remove();
              }
            });
          }

          // Auto-open product description accordion (but NOT for Ready Made
          // quick views â€” user wants those to start collapsed).
          if (trigger.getAttribute('data-url').includes('/products/') &&
              trigger.getAttribute('data-quickview') !== 'ready-made') {
            setTimeout(() => ucOpenProductAccordions(contentEl), 50);
          }

          // Scroll to hash anchor if present
          if (hash) {
            setTimeout(() => {
              const targetElement = contentEl.querySelector(hash);
              if (targetElement) targetElement.scrollIntoView({ behavior: 'smooth' });
            }, 100);
          }
        } else {
          contentEl.innerHTML = 'Failed to load content. Please try again.';
        }
      })
      .catch((err) => {
        // Logged so a bug in the render/strip logic is distinguishable from
        // an actual network failure.
        console.error('[uc-drawer]', err);
        if (requestToken !== ucOpenDrawer._token) return;
        contentEl.innerHTML = 'Failed to load content. Please try again.';
      });
  }

  function ucCloseDrawer() {
    document.getElementById('uc-drawer').hide();
  }

  // Auto-close drawer on add-to-cart button click
  document.addEventListener('click', (event) => {
    const atc = event.target.closest && event.target.closest('button.button.button--xl[is="custom-button"]');
    // Scope to the drawer: this selector also matches every PDP add-to-cart,
    // so an unscoped handler closed a quick view opened within 1.5s of one.
    if (atc && atc.closest('#uc-drawer')) {
      setTimeout(() => ucCloseDrawer(), 1500);
    }
  });

  window.ucOpenDrawer = ucOpenDrawer;
  window.ucCloseDrawer = ucCloseDrawer;
})();

/* ==================================================================================================
   PRODUCT GALLERY â€” review slide support + desktop thumbnail hover
   ================================================================================================== */
(function () {
  /* ---------------------------------------------------------------------------------------------
     1. Variant-change index correction
     snippets/product-gallery-review-slide.liquid injects a synthetic slide as the 2nd DOM child of
     <media-carousel>. Liquid shifts the indices it emits (initial-index, filtered-indexes), but
     theme.js computes the target itself on variant change:
         newMediaPosition = variant.featured_media.position - 1
     which is one short for every media after the injected slide. Re-select with the right index
     once theme.js has run.
     --------------------------------------------------------------------------------------------- */
  function correctedIndex(carousel, mediaPosition) {
    const slides = Array.from(carousel.children);
    const reviewIndex = slides.findIndex((s) => s.getAttribute('data-media-type') === 'review');
    if (reviewIndex === -1) return mediaPosition - 1;
    return mediaPosition - 1 >= reviewIndex ? mediaPosition : mediaPosition - 1;
  }

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.featured_media) return;

    const formId = event.target && event.target.id;
    const gallery = formId ? document.querySelector(`product-gallery[form="${formId}"]`) : null;
    if (!gallery || !gallery.querySelector('[data-media-type="review"]')) return;

    gallery.querySelectorAll('media-carousel').forEach((carousel) => {
      if (typeof carousel.select !== 'function') return;
      carousel.select(correctedIndex(carousel, variant.featured_media.position), { animate: false });
    });
  });

  /* ---------------------------------------------------------------------------------------------
     2. Keep the prev/next hover cursor on the review slide
     theme.js hides <custom-cursor> whenever the selected slide's data-media-type isn't "image"
     (so it disappears on video/model slides). Our review slide is still a normal navigable slide,
     so put the cursor back when it's the one selected.
     --------------------------------------------------------------------------------------------- */
  document.addEventListener('carousel:change', (event) => {
    const gallery = event.target.closest && event.target.closest('product-gallery');
    if (!gallery) return;

    const cursor = gallery.querySelector('.product-gallery__cursor');
    const slide = event.detail && event.detail.slide;
    if (!cursor || !slide) return;

    if (slide.getAttribute('data-media-type') === 'review') {
      // Runs after theme.js's own handler, so this wins.
      cursor.removeAttribute('hidden');
    }
  });

  /* ---------------------------------------------------------------------------------------------
     3. Click-to-navigate on the review slide
     theme.js `_onGalleryClick` bails whenever the selected slide isn't an image â€” that guard exists
     to stop clicks hijacking video/model slides, but it also kills prev/next on our review slide.

     This MUST run in the capture phase. theme.js binds its handler on <media-carousel>, so a
     bubble-phase listener would see `selectedSlide` *after* theme.js had already advanced â€”
     landing us one slide too far and appearing to skip the review slide. Capturing at the document
     lets us read the pre-click selection, and stopPropagation keeps theme.js from acting on the
     same click (it would otherwise navigate again, now that an image is selected).
     --------------------------------------------------------------------------------------------- */
  document.addEventListener('click', (event) => {
    // Mirror theme.js's own guards
    if (event.target.closest('button, a[href]')) return;
    if (!window.matchMedia('screen and (pointer: fine)').matches) return;

    const carousel = event.target.closest && event.target.closest('media-carousel');
    if (!carousel || typeof carousel.next !== 'function') return;

    const selected = carousel.selectedSlide;
    if (!selected || selected.getAttribute('data-media-type') !== 'review') return;

    event.stopPropagation();

    const rect = carousel.getBoundingClientRect();
    if (event.clientX - rect.left > carousel.clientWidth / 2) {
      carousel.next();
    } else {
      carousel.previous();
    }
  }, true);

  /* ---------------------------------------------------------------------------------------------
     4. "Read all N" â†’ scroll to the Judge.me widget
     There is no #shopify-product-reviews anchor in this theme â€” Judge.me injects its widget at
     runtime with no stable id, and the wrapping section id differs per template. So resolve the
     widget by its own class at click time and scroll to it. The href stays as a no-JS fallback.
     --------------------------------------------------------------------------------------------- */
  const REVIEW_WIDGET_SELECTOR = [
    '.jm-review-widget',
    '.jdgm-review-widget',
    '.jdgm-rev-widg',
    '#judgeme_product_reviews'
  ].join(', ');

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('.product-gallery__review-link');
    if (!link) return;

    const widget = document.querySelector(REVIEW_WIDGET_SELECTOR);
    if (!widget) return; // let the href do whatever it can

    event.preventDefault();

    // Prefer the enclosing section so the "Customer Reviews" heading is in view too
    const target = widget.closest('.shopify-section') || widget;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------------------------------------------------------------------------------------------
     5. Desktop: hovering a thumbnail swaps the main image
     Opt-in via the "Change image on thumbnail hover" setting, which adds
     .product-gallery--thumbnail-hover. Pointer-fine only, so touch devices keep tap-to-select.
     --------------------------------------------------------------------------------------------- */
  const HOVER_DELAY = 60;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('mouseover', (event) => {
    if (!finePointer.matches) return;

    const thumb = event.target.closest && event.target.closest('.product-gallery__thumbnail');
    if (!thumb) return;

    const gallery = thumb.closest('product-gallery.product-gallery--thumbnail-hover');
    if (!gallery) return;

    const list = thumb.parentElement;
    if (!list) return;

    const index = Array.from(list.children).indexOf(thumb);
    if (index === -1) return;

    clearTimeout(list._ucHoverTimer);
    list._ucHoverTimer = setTimeout(() => {
      gallery.querySelectorAll('media-carousel').forEach((carousel) => {
        if (typeof carousel.select === 'function') {
          carousel.select(index, { animate: false });
        }
      });
    }, HOVER_DELAY);
  });

  document.addEventListener('mouseout', (event) => {
    const thumb = event.target.closest && event.target.closest('.product-gallery__thumbnail');
    if (thumb && thumb.parentElement) clearTimeout(thumb.parentElement._ucHoverTimer);
  });
})();

/* Auto-Gift Engine
 *
 * Adds and removes gift lines to match the rules in window.UC_GIFT_RULES
 * (see snippets/gift-rules.liquid). Lines we own are tagged with the
 * `_Gifted` line-item property, whose value is the rule name — that
 * property is the ONLY thing marking a line as ours, so we never touch a
 * copy of the same product the customer paid for.
 *
 * Lives here, not in theme.js: an Impact upgrade replaces theme.js wholesale
 * (7.2.0 was a re-application, not a merge), so store logic put there is
 * lost at the next version bump.
 */
(() => {
  const PROPERTY = '_Gifted';
  const OWNER_PROPERTY = '_GiftedBy';
  const OWNER = 'uc-auto-gift';
  const MAX_PASSES = 5;
  const STATE_KEY = 'uc:gift:state';
  // Marks the engine's OWN cart writes so the network watcher at the foot of
  // this file can ignore them. Without it the watcher sees our add,
  // reconciles, and adds again - the very loop desired===actual prevents.
  const OWN_HEADER = 'X-UC-Gift-Engine';

  // Product types that do not count toward a rule's threshold. Matched
  // case-insensitively because Shopify product types are free text.
  const EXCLUDED_TYPES = new Set([
    'bondage rope',
    'wax play candles',
    'gags',
    'accessories',
    'accessories & upgrades',
    'lubricants',
    'gift cards',
    'customisation',
    'free gift',
    'giftbox_ghost_product',
    'options_price',
  ]);

  const rules = () => window.UC_GIFT_RULES || [];
  const norm = (s) => (s || '').trim().toLowerCase();

  /* ── Ownership ────────────────────────────────────────────────────────
   * `_Gifted: <rule name>` is a convention we SHARE with the EasyGift app
   * (cdn.506.io), which is still installed and manages the same Mystery
   * Dildo product. So the presence of `_Gifted` alone does NOT mean we put
   * the line there, and acting as though it did is destructive: the orphan
   * sweep below would delete EasyGift's line (its rule name is not in our
   * rule list), EasyGift would re-add it, and the two would fight — both
   * POSTing to /cart concurrently, which surfaces as a cart error and a
   * gift that vanishes on page load.
   *
   * `_GiftedBy` is our own marker. Ownership requires it, so we can only
   * ever remove or re-quantify lines this engine created. Anything else
   * with `_Gifted` is another system's business and is left alone.
   *
   * Both properties are `_`-prefixed, so neither renders customer-facing
   * (see the property loop in snippets/line-item.liquid) while both stay
   * visible on the order in admin.
   */
  const giftedName = (line) => line.properties?.[PROPERTY] || null;
  const isGifted = (line) => Boolean(giftedName(line));       // ANY system's gift
  const ruleNameOf = (line) =>                                 // ours only
    line.properties?.[OWNER_PROPERTY] === OWNER ? giftedName(line) : null;

  /* ── Threshold basis ──────────────────────────────────────────────────
   * A line counts unless its type is excluded OR we added it ourselves.
   * The self-check is load-bearing independently of EXCLUDED_TYPES: a gift
   * whose product_type is not on the list would otherwise inflate the very
   * subtotal that justified it, and could self-promote the cart into a
   * higher tier that then justifies a second gift. A gift must never help
   * pay for itself.
   *
   * final_line_price (not original_line_price) so a discount code that
   * drops the customer under the threshold correctly retracts the gift.
   * All cart.js money values are integer minor units (pence).
   */
  /* `gift_card` is checked separately from EXCLUDED_TYPES because the type
   * string is not reliable for this: Sinnovator's "Sinnovator Gift Card" has
   * a BLANK product_type, so the 'gift cards' entry never matches it and a
   * £50 gift card would earn a free gift. cart.js exposes an authoritative
   * per-line boolean, so use that and let the type entry cover the rest.
   */
  const counts = (line, upgradeIds) =>
    !isGifted(line) &&
    !line.gift_card &&
    !upgradeIds.has(line.product_id) &&
    !EXCLUDED_TYPES.has(norm(line.product_type));

  const eligibleSubtotal = (cart, upgradeIds) =>
    cart.items.reduce((sum, line) => (counts(line, upgradeIds) ? sum + line.final_line_price : sum), 0);

  const qualifies = (rule, subtotal) =>
    subtotal >= (rule.min_subtotal ?? 0) &&
    (rule.max_subtotal == null || subtotal < rule.max_subtotal);

  /* ── Upgrade products ─────────────────────────────────────────────────
   * The Mystery Dildo size-upgrade is a PAID product priced on the
   * assumption that the customer already earned the free mystery — it
   * upgrades the gift rather than being bought on its own merits. That
   * gives it three linked behaviours, all from one list:
   *
   *   1. It SUPPRESSES the gift. The larger mystery is what ships, so the
   *      free X-Small must go. (The Mechanic task
   *      `remove-free-mystery-dildo-on-upgrade` also does this, but only on
   *      orders/create — after checkout, by order edit. Doing it in the cart
   *      means the customer never sees a gift that later vanishes from their
   *      order, and leaves Mechanic as the backstop.)
   *
   *   2. It does NOT COUNT toward the threshold. An upgrade must not help
   *      pay for the eligibility that justifies it, for the same reason a
   *      gift must not — otherwise the upgrade alone can self-qualify.
   *
   *   3. It is REMOVED when the spend condition fails. Without this the
   *      customer adds a product, takes the gift, buys the upgrade, then
   *      deletes the original product and keeps a heavily discounted
   *      mystery they never qualified for.
   *
   * Note (3) keys on the SPEND test alone, never on `earned` — `earned`
   * already accounts for (1), so using it here would be circular: the
   * upgrade would suppress the gift, that would read as "not earned", and
   * the upgrade would delete itself the moment it was added.
   */
  const upgradeIdsOf = (rule) => rule.upgrade_product_ids || [];

  /* ── Per-rule session state ───────────────────────────────────────────
   * { "<rule name>": { added: bool, dismissedAt: pence|null } }
   *
   * `added` records that WE successfully put this gift in the cart. If it
   * later disappears while the cart still qualifies, the customer deleted
   * it — which is how a manual removal is detected without hanging any hook
   * off the cart markup. Re-adding it immediately would mean they could
   * never get rid of it.
   *
   * `dismissedAt` is the eligible subtotal at the moment they deleted it.
   * The gift is re-offered as soon as that subtotal INCREASES: adding
   * another product is a fresh purchase decision. Removing a product is
   * not, so a shrinking cart stays dismissed — but the recorded figure
   * follows it down, so any later increase still re-offers. Dropping below
   * the threshold clears the dismissal outright.
   */
  const loadState = () => {
    try { return JSON.parse(sessionStorage.getItem(STATE_KEY) || '{}'); }
    catch { return {}; }
  };
  const saveState = (state) => {
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(state)); }
    catch { /* private mode — engine still works, dismissals just won't persist */ }
  };

  /* ── Serialized cart writes ───────────────────────────────────────────
   * Concurrent /cart/*.js calls against one session interleave, and ANY
   * mutation invalidates every line key captured before it. So writes are
   * strictly ordered and keys are always re-read from a fresh cart.
   */
  let chain = Promise.resolve();
  function serial(fn) {
    const running = chain.then(fn, fn);
    chain = running.catch(() => {});
    return running;
  }

  async function addGift(rule) {
    const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // needed for Shopify to check inventory
        [OWN_HEADER]: '1',
      },
      body: JSON.stringify({
        items: [{
          id: rule.variant_id,
          quantity: rule.quantity || 1,
          properties: { [PROPERTY]: rule.name, [OWNER_PROPERTY]: OWNER },
        }],
      }),
    });
    if (!res.ok) {
      // Almost always out of stock. Never retry in-loop and never block the
      // customer — the cart is still valid without the gift.
      console.warn(`[gift] could not add "${rule.name}":`, (await res.json())?.description);
      return false;
    }
    return true;
  }

  async function setLineQuantity(lineKey, quantity) {
    const res = await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', [OWN_HEADER]: '1' },
      body: JSON.stringify({ id: lineKey, quantity }),
    });
    if (!res.ok) {
      console.warn('[gift] could not change line', lineKey, (await res.json())?.description);
      return false;
    }
    return true;
  }

  /* ── Reconcile ────────────────────────────────────────────────────────
   * Idempotent state machine: compute the gift lines the cart SHOULD have,
   * diff against what it HAS, apply the difference. When desired === actual
   * it does nothing — that no-op is what stops cart:change → add →
   * cart:change from looping. MAX_PASSES is a backstop so a rule bug cannot
   * spin the browser or hammer Shopify.
   */
  async function reconcile(pass = 0) {
    if (pass >= MAX_PASSES) {
      console.warn('[gift] pass cap reached, giving up');
      return;
    }

    const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    const state = loadState();
    const active = rules();
    const upgradeIds = new Set(active.flatMap(upgradeIdsOf));
    const subtotal = eligibleSubtotal(cart, upgradeIds);
    const known = new Set(active.map((r) => r.name));
    let mutated = false;

    // 1. Drop orphans: gift lines whose rule was renamed or deleted. Left
    //    alone they sit in the cart forever, at whatever price the discount
    //    no longer zeroes.
    for (const line of cart.items) {
      const name = ruleNameOf(line);
      if (name && !known.has(name)) {
        if (await setLineQuantity(line.key, 0)) mutated = true;
      }
    }

    /* 2. Customer-added gift lines.
     *    The gift product is unlisted (seo.hidden), not unpublished — so it
     *    is still reachable by direct URL and by /cart/<variant>:1 permalink,
     *    and nothing server-side stops someone adding a £0 product by hand.
     *    This is EasyGift's `preventAddedItemPurchase`, which is currently
     *    OFF on the UC rule, so the hole is open today.
     *
     *    The three-way test matters for coexistence: OUR line carries
     *    _GiftedBy, EasyGift's carries _Gifted alone, and a hand-added line
     *    carries neither. Only the last is removed — an unclaimed line is
     *    the only one that can be a manual add. Per-rule opt-out via
     *    prevent_manual_add: false, in case it ever fights another app.
     */
    const guarded = new Map(
      active.filter((r) => r.prevent_manual_add !== false).map((r) => [r.variant_id, r]),
    );
    for (const line of cart.items) {
      const guard = guarded.get(line.variant_id);
      if (!guard) continue;
      if (ruleNameOf(line)) continue;   // ours — the per-rule loop below owns it
      // A line carrying _Gifted but not _GiftedBy belongs to another gift
      // system. While EasyGift is installed that must be left alone. Once it
      // is uninstalled its lines are stranded in live carts — nothing will
      // ever clean them — so `exclusive: true` claims the variant outright
      // and sweeps them too. Flip it in gift-rules.liquid at uninstall.
      if (isGifted(line) && !guard.exclusive) continue;
      if (await setLineQuantity(line.key, 0)) mutated = true;
    }

    for (const rule of active) {
      const st = state[rule.name] || (state[rule.name] = { added: false, dismissedAt: null });
      const upgrades = upgradeIdsOf(rule);
      const meetsSpend = qualifies(rule, subtotal);

      /* Upgrade lines depend on the spend condition alone (see (3) above),
       * and are capped at the number of gifts the rule actually grants — an
       * upgrade upgrades THE GIFT, so one entitlement supports one upgrade.
       * Nothing else caps it: the Mechanic task pointedly never touches the
       * upgrade product ("a paid item can't be deleted"), so without this a
       * customer can hold 10 heavily discounted mysteries behind a single
       * entitlement. Changing an upgrade line never moves `subtotal` —
       * upgrades are excluded from it — so this cannot oscillate.
       */
      const upgradeLines = upgrades.length
        ? cart.items.filter((l) => upgrades.includes(l.product_id))
        : [];
      if (upgradeLines.length) {
        /* When the customer switches size — cart holds "X-Small > Small",
         * they add "X-Small > Medium" — the size they just chose must be the
         * one that survives the cap. cart.js line ORDER cannot decide that:
         * Shopify does not guarantee new lines are appended last, and reading
         * it as recency kept the OLD size and deleted the one they had just
         * picked, so switching size looked broken.
         *
         * Instead, remember which upgrade line keys survived the previous
         * reconcile. A key we have not seen before is, by definition, the one
         * the customer just added. Line keys are `variant:hash-of-properties`
         * and stable for a given variant + properties, so this is exact
         * rather than positional. Falls back to array order only on a fresh
         * session, where nothing has been seen yet.
         */
        const seen = new Set(st.upgradeKeys || []);
        const ordered = [
          ...upgradeLines.filter((l) => !seen.has(l.key)),
          ...upgradeLines.filter((l) => seen.has(l.key)),
        ];
        let remaining = meetsSpend ? (rule.quantity || 1) : 0;
        const survivors = [];
        for (const line of ordered) {
          const keep = Math.min(line.quantity, remaining);
          remaining -= keep;
          if (keep !== line.quantity && await setLineQuantity(line.key, keep)) mutated = true;
          if (keep > 0) survivors.push(line.key);
        }
        st.upgradeKeys = survivors;
      } else {
        st.upgradeKeys = [];
      }

      // A suppressed rule is treated exactly as an unqualified one, so the
      // retract-and-reset path below is shared: adding the size upgrade
      // removes the gift, and removing the upgrade offers it again.
      const hasUpgrade = cart.items.some((l) => upgrades.includes(l.product_id));
      const earned = meetsSpend && !hasUpgrade;

      // Rule lapsed — full reset, so re-crossing the threshold offers afresh.
      if (!earned) {
        st.added = false;
        st.dismissedAt = null;
      } else if (st.dismissedAt != null) {
        if (subtotal > st.dismissedAt) st.dismissedAt = null;          // they added something
        else if (subtotal < st.dismissedAt) st.dismissedAt = subtotal; // follow the cart down
      }

      const ours = cart.items.filter((l) => ruleNameOf(l) === rule.name);

      // 3. Remove gift lines on the wrong variant (rule repointed at a new
      //    product) before counting quantity, or the diff below sees the
      //    right count on the wrong item and no-ops.
      const stale = ours.filter((l) => l.variant_id !== rule.variant_id);
      for (const line of stale) {
        if (await setLineQuantity(line.key, 0)) mutated = true;
      }

      const current = ours.filter((l) => l.variant_id === rule.variant_id);
      const actual = current.reduce((n, l) => n + l.quantity, 0);

      // 4. Manual deletion: we put it there, it qualifies, and it's gone.
      //    Record the dismissal rather than silently re-adding it.
      //    Clearing `added` here consumes the signal — leave it set and the
      //    next subtotal increase clears dismissedAt only for this same check
      //    to re-dismiss it on the spot, and the gift can never come back.
      if (earned && st.added && actual === 0 && st.dismissedAt == null) {
        st.dismissedAt = subtotal;
        st.added = false;
      }

      const desired = earned && st.dismissedAt == null ? (rule.quantity || 1) : 0;

      if (desired === actual && stale.length === 0) continue; // ← the loop breaker

      if (desired === 0) {
        // 5. Conditions no longer met (or dismissed) — retract every line.
        for (const line of current) {
          if (await setLineQuantity(line.key, 0)) mutated = true;
        }
        st.added = false;
      } else if (actual === 0) {
        if (await addGift(rule)) {
          st.added = true;
          mutated = true;
        }
      } else {
        // 6. Collapse to a single line at exactly the rule quantity. This is
        //    what stops the customer bumping the free item to qty 5 with the
        //    stepper — custom.css hides that control on gift lines, but the
        //    cart is the only authority, so it is re-clamped here regardless.
        const [keep, ...extra] = current;
        for (const line of extra) {
          if (await setLineQuantity(line.key, 0)) mutated = true;
        }
        if (keep.quantity !== desired && await setLineQuantity(keep.key, desired)) mutated = true;
        st.added = true;
      }
    }

    saveState(state);

    if (mutated) {
      // Re-run against the new cart: removing an ORPHAN changes the eligible
      // subtotal, and a tiered rule set may need a second pass to settle.
      await reconcile(pass + 1);

      /* Only then repaint, and only once.
       *
       * Drawer/popover: the sections bundled into the /cart/add.js response
       * were rendered BEFORE we touched the cart, so cart:change alone paints
       * a drawer with no gift in it. cart:refresh is the only full re-render.
       *
       * Cart PAGE: cart:refresh re-renders the drawer, not the page, so the
       * retracted gift would sit there looking present until the next load.
       * The theme has the same problem with its own line-item edits and
       * solves it by reloading (see LineItemQuantity._changeLineItemQuantity,
       * which reloads instead of dispatching cart:change when pageType is
       * 'cart' — that is also why our cart:change listener never fires here).
       * Reloading cannot loop: reconcile is idempotent, so the next pass
       * finds desired === actual and never sets mutated.
       */
      if (pass === 0) {
        if (window.themeVariables?.settings?.pageType === 'cart') {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      }
    }
  }

  /* Reconcile work outstanding right now: a pass running, or a debounced one
   * about to start. The checkout guard at the foot of this file waits on it. */
  let inFlight = 0;
  let debounceArmed = false;
  const isBusy = () => inFlight > 0 || debounceArmed;

  const run = () => {
    inFlight++;
    return serial(() => reconcile().catch((e) => console.warn('[gift]', e)))
      .finally(() => { inFlight--; });
  };

  /* ── Triggers ─────────────────────────────────────────────────────────
   * Our own fetches never dispatch cart:change, so reconcile cannot
   * re-trigger itself — settling is handled by the recursion above. The
   * theme dispatches cart:change on documentElement for both adds and
   * quantity edits, and it bubbles to this listener on document.
   */
  document.addEventListener('cart:change', run);

  /* -- Cart writes made by code that does not announce them --------------
   * cart:change is a THEME convention; nothing obliges an app to honour it.
   * Live Product Options (Cloudlift) POSTs /cart/add.js itself and dispatches
   * only its own cloudlift.cart / cloudlift.ajax (both bubbles: false), lpo
   * and options:* events - verified against app-options 0.15.73, which holds
   * ZERO occurrences of 'cart:change' (bundle kept at
   * uc-options-engine/vendor-backup/). On an LPO store the gift is therefore
   * added only when the customer happens to load a full page after
   * configuring a product, and that is most of the attach-rate gap: it is why
   * Sinnovator still misses, and why UC's misses stop at the 2026-09-07
   * cutover to uc-options, which does dispatch cart:change.
   *
   * So watch the NETWORK rather than the event. Any successful cart write
   * reconciles, whoever made it - which also covers whatever replaces LPO.
   * Our own writes carry OWN_HEADER and are skipped, or this recurses.
   */
  const CART_WRITE = new RegExp('/cart/(add|change|update|clear)([.]js)?$');

  const isCartWrite = (url) => {
    try { return CART_WRITE.test(new URL(url, window.location.origin).pathname); }
    catch { return false; }
  };

  // Coalesce: a theme add fires cart:change AND this, and a cart-page bulk
  // edit fires several writes in a row. reconcile is idempotent, so the extra
  // passes would be harmless - just wasteful.
  let debounceTimer;
  const runSoon = () => {
    clearTimeout(debounceTimer);
    // The debounce window counts as busy: nothing is in flight yet, but a
    // reconcile is imminent and checking out now would still lose the gift.
    debounceArmed = true;
    debounceTimer = setTimeout(() => { debounceArmed = false; run(); }, 50);
  };

  const nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      let own = false;
      let url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
        const src = (init && init.headers) || (typeof input === 'object' && input && input.headers);
        if (src) own = new Headers(src).has(OWN_HEADER);
      } catch { /* exotic input - treat as third-party and let it reconcile */ }
      const res = nativeFetch.apply(this, arguments);
      if (!own && url && isCartWrite(url)) {
        Promise.resolve(res).then((r) => { if (r && r.ok) runSoon(); }).catch(() => {});
      }
      return res;
    };
  }

  /* Shopify's own cart JS and a number of apps still use XHR. */
  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSetHeader = XMLHttpRequest.prototype.setRequestHeader;
  const nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._ucCartWrite = /post/i.test(method || '') && isCartWrite(url || '');
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.setRequestHeader = function (name) {
    if (String(name).toLowerCase() === OWN_HEADER.toLowerCase()) this._ucOwn = true;
    return nativeSetHeader.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._ucCartWrite && !this._ucOwn) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) runSoon();
      });
    }
    return nativeSend.apply(this, arguments);
  };

  // Catch carts mutated elsewhere — another tab, an app, returning from
  // checkout. Skip the request entirely when the cart is visibly empty.
  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('cart-count')?.textContent.trim() === '0') return;
    run();
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) run(); });

  /* -- Do not let the customer check out mid-reconcile -------------------
   * Adding a product and clicking Checkout straight away is a real race: a
   * reconcile is a 50ms debounce plus two or three round trips, and nothing
   * in the theme waits for it. The customer reaches checkout with no gift,
   * and the order lands as a miss indistinguishable from one where the
   * engine never ran at all.
   *
   * Both the drawer (sections/cart-drawer.liquid) and the cart page
   * (sections/main-cart.liquid) render the same control: a submit button
   * named 'checkout' inside a form POSTing to /cart. Intercept in the
   * CAPTURE phase so we act before the theme, then replay the original
   * action once idle - replays are marked so the guard lets them through.
   *
   * The wait is capped. A hung request must never strand somebody on the
   * checkout button: a missing gift is far cheaper than a lost order.
   *
   * NOT covered: the wallet buttons from
   * content_for_additional_checkout_buttons (Shop Pay, PayPal). They render
   * in cross-origin iframes and cannot be intercepted from here, so they
   * stay racy. Only a server-side backstop could close those.
   */
  const CHECKOUT_WAIT_MS = 3000;
  const replaying = new WeakSet();

  async function settle() {
    const deadline = Date.now() + CHECKOUT_WAIT_MS;
    /* Poll on a REAL timer. Awaiting the write chain directly spins on an
     * already-resolved promise and yields only to the microtask queue, which
     * starves macrotasks: timers stop firing, the debounced pass never runs,
     * and the tab freezes for the whole cap. 25ms is imperceptible against a
     * checkout navigation. */
    while (isBusy() && Date.now() < deadline) {
      await new Promise((r) => setTimeout(r, 25));
    }
  }

  const isCheckoutControl = (el) =>
    Boolean(el) && el.name === 'checkout' &&
    (el.tagName === 'BUTTON' || el.tagName === 'INPUT');

  document.addEventListener('click', (event) => {
    const el = event.target && event.target.closest && event.target.closest('[name="checkout"]');
    if (!isCheckoutControl(el)) return;
    if (replaying.has(el)) { replaying.delete(el); return; }
    if (!isBusy()) return;
    event.preventDefault();
    event.stopPropagation();
    el.setAttribute('aria-busy', 'true');
    settle().then(() => {
      el.removeAttribute('aria-busy');
      replaying.add(el);
      el.click();
    });
  }, true);

  /* Submitting with the keyboard never fires a click on the button. */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const submitter = event.submitter;
    if (!isCheckoutControl(submitter)) return;
    if (replaying.has(form)) { replaying.delete(form); return; }
    if (!isBusy()) return;
    event.preventDefault();
    event.stopPropagation();
    settle().then(() => {
      replaying.add(form);
      if (form.requestSubmit) form.requestSubmit(submitter);
      else form.submit();
    });
  }, true);
})();
